module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/adress-book-1-556fbc00a2f55e58c89e7408782f2f4a.svg";